import React from 'react';
import './uploadedFileList.module.scss';
import { UserFileShowView, UserFileToken } from '../../../types/uploadedFiles';
import { UploadedFileSummary } from './UploadedFileSummary';
import { TransitionGroup } from 'react-transition-group';
import { Fade } from '../../../../commonv3/components/atoms/animation/Fade';

type Props = {
    files: UserFileShowView[];
    onRequestDelete: (token: UserFileToken) => any;
};

export const UploadedFileList = ({ files, onRequestDelete }: Props) => {
    return (
        <div styleName="uploaded-file-list">
            <TransitionGroup>
                {files.length > 0 && (
                    <Fade>
                        <div styleName="header">アップロード済みのファイル</div>
                    </Fade>
                )}
                {files.map((file) => (
                    <Fade key={file.token}>
                        <UploadedFileSummary file={file} onRequestDelete={onRequestDelete} />
                    </Fade>
                ))}
            </TransitionGroup>
        </div>
    );
};
